<template>
  <el-dialog
    :title="dialogtitle"
    :visible.sync="dialogVisible"
    @close="$emit('update:visible',false)"
  >
    <div class="dialog_conwrap">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
        <el-form-item label="分类名称:" prop="name">
          <el-input v-model="formdata.name" placeholder="建议不要超过4个中文"></el-input>
        </el-form-item>
        <el-form-item label="分类排序:" prop="sort">
          <el-input type="number" v-model="formdata.sort" :min="0" placeholder="请输入数字排序值(值越小越靠前)"></el-input>
        </el-form-item>        
        <el-form-item label="分类logo">
          <uploadImg @getChildValue="getChildValue" imgNumber="1" page="goodsSpecificationDialog"
                     :picSrc="formdata.pic"></uploadImg>
        </el-form-item>
        <el-form-item label="上级分类:">
          <el-select v-model="formdata.parent_id" placeholder="请选择">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>        
        <!-- <el-form-item label="分类图片">
          <el-upload
            class="avatar-uploader"
            :action="uploadurl"
            :show-file-list="false"
            :data="data_"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
          >
            <img v-if="formdata.pic!==''" :src="formdata.pic" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <div slot="tip" class="el-upload__tip">建议图片尺寸：100*100</div>
          </el-upload>
        </el-form-item> -->
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
import uploadImg from "@/components/dialog/uploadImg.vue";
export default {
  name: "goodsSpecificationDialog",
  props: ["visible", "type", "classifyitem"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  components: {
      uploadImg
    },
  data() {
    var validateSort = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入分类排序值'));
      } else {
        if (value < 0) {
          callback(new Error('值不能小于0'));
        } else {
          callback();
        }  
      }
    };
    return {
      dialogtitle: "新增分类",
      dialogVisible: this.visible,
      data_: {token: sessionStorage.getItem("token")},
      formdata: {
        cate_id: "",
        name: "",
        parent_id: "",
        pic: "",
        sort: ""
      },
      uploadurl: api.uploadTokenImg,
      options: [],
      lock: true,
      rules: {
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
        sort: [{ required: true, validator: validateSort, trigger: 'blur' }]
      },
      catelogo:""
    };
  },
  created() {
    if (this.type === "edit") {
      this.dialogtitle = "编辑分类";
      this.formdata.cate_id = this.classifyitem.id;
      this.formdata.name = this.classifyitem.name;
      this.formdata.sort = this.classifyitem.sort;
      this.formdata.parent_id = this.classifyitem.parent_id;
      this.formdata.pic = this.classifyitem.pic;
    }
    this.queryparentclassify();
  },
  methods: {
    getChildValue(option) {
        console.log('option',option)
        this.formdata.pic = option
    },
    // 查询父级分类
    queryparentclassify() {
      let params = {};
      this.axios
        .post(api.goods_cate_parent_list, params)
        .then(response => {
          if (response.data.code == 0) {
            this.options = response.data.list || [];
          } else {
          }
        })
        .catch(() => {});
    },
    handleSuccess(res, file) {
      if (res.code === 0) {
        this.formdata.pic = res.path;
      } else {
        this.$message.error(res.msg);
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或者PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
      }
      return isJPG && isLt2M;
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.lock) {
            this.lock = false;
            if (this.type === "edit") {
              this.submiteditsave();
            } else {
              this.submitsave();
            }
          }
        } else {
          return false;
        }
      });
    },
    // 提交保存
    submitsave() {
      let params = {
        name: this.formdata.name,
        parent_id: this.formdata.parent_id,
        pic: this.formdata.pic
      };
      this.axios
        .post(api.goods_cate_add, params)
        .then(response => {
          this.lock = true;
          if (response.data.code == 0) {
            this.dialogVisible = false;
            this.$emit("classifysuccess");
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    },
    // 提交编辑保存
    submiteditsave() {
      let params = {
        cate_id: this.formdata.cate_id,
        name: this.formdata.name,
        sort: this.formdata.sort,
        parent_id: this.formdata.parent_id,
        pic: this.formdata.pic
      };
      this.axios
        .post(api.goods_cate_edit, params)
        .then(response => {
          
          this.lock = true;
          if (response.data.code == 0) {
            this.dialogVisible = false;
            this.$emit("classifysuccess");
          } else {
          }
        })
        .catch(response => {
          this.lock = true;
        });
    }
  }
};
</script>

